import { render } from "./TheCoats.vue?vue&type=template&id=be19f23a&scoped=true"
import script from "./TheCoats.vue?vue&type=script&lang=js"
export * from "./TheCoats.vue?vue&type=script&lang=js"

import "./TheCoats.vue?vue&type=style&index=0&id=be19f23a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be19f23a"]])

export default __exports__